import { render, staticRenderFns } from "./Sitetape.vue?vue&type=template&id=b33f0422&scoped=true&"
var script = {}
import style0 from "./Sitetape.vue?vue&type=style&index=0&id=b33f0422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33f0422",
  null
  
)

export default component.exports